import { render, staticRenderFns } from "./doctorInfo.vue?vue&type=template&id=614d1a13&scoped=true&"
import script from "./doctorInfo.vue?vue&type=script&lang=js&"
export * from "./doctorInfo.vue?vue&type=script&lang=js&"
import style0 from "./doctorInfo.vue?vue&type=style&index=0&id=614d1a13&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614d1a13",
  null
  
)

export default component.exports